module.exports = __webpack_public_path__ + "static/media/MiscGroup.1055d6b2.svg";